import * as SurveyCore from "survey-core";
import i18next from "../../common/localization/i18n";

export default function GlobalUnsubscribeEmail() {
  if (!SurveyCore.Serializer.findClass("global_unsubscribe_email")) {
    SurveyCore.ComponentCollection.Instance.add({
      name: "global_unsubscribe_email",
      title: i18next.t("NEW_SUBSCRIPTIONS_EDITOR.UNSUBSCRIBE_ALL_EMAIL.TITLE"),
      iconName: "icon-global-unsubscribe-email",
      elementsJSON: [
        {
          type: "checkbox",
          name: "unsubscribe_all_email",
          titleLocation: "hidden",
          choices: [
            i18next.t(
              "NEW_SUBSCRIPTIONS_EDITOR.UNSUBSCRIBE_ALL_EMAIL.CHOICES.UNSUBSCRIBE_ALL_EMAIL",
            ),
          ],
        },
      ],
      onLoaded: (question) => {
        const checkbox = question.contentPanel.getQuestionByName("unsubscribe_all_email");
        if (!checkbox) return;

        checkbox.choices = [question.title];

        question.registerFunctionOnPropertyValueChanged("title", () => {
          checkbox.choices = [question.title];
        });
      },
    });
  }
}
